import { render, staticRenderFns } from "./TheVersionInfo.vue?vue&type=template&id=38acdb7a&scoped=true"
import script from "./TheVersionInfo.vue?vue&type=script&lang=js"
export * from "./TheVersionInfo.vue?vue&type=script&lang=js"
import style0 from "./TheVersionInfo.vue?vue&type=style&index=0&id=38acdb7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38acdb7a",
  null
  
)

export default component.exports